/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Sep-17
 *
 **/

import Vue from "vue"
import VueRouter from "vue-router"

import PanelWebRoutes from './web/config/router'
import PanelMobileRoutes from './web/config/router'
import Constants from "bestgob-core/core/constants";
import * as Storage from 'bestgob-core/core/storage.js'

Vue.use(VueRouter)

let defaultRoutes = PanelWebRoutes
if (process.env.VUE_APP_MODULE === 'mobile'){
    defaultRoutes = PanelMobileRoutes
}

const router = new VueRouter({
    mode: "history",
    routes: defaultRoutes
})


router.beforeEach((to, from, next) => {
    let user = Storage.getItem(Constants.KEY_USER);
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!user) {
        router.push({ name: 'landing' }).catch(error=>{
            console.log(error);
        })
        

      } else {
        next() // go to wherever I'm going
      }
    }else if( user && to.name == 'landing'){
      router.push({ name: 'home' }).catch(error=>{
        console.log(error);
      })
    }
    else{
      next() // does not require auth, make sure to always call next()!
    }
});

export default router

